import './input.css';

import { translate } from '../../../../common/language/translations';

import skill_corner_logo from '../../../../assets/images/skillcorner_logo_green.png';
import BlockIcon from '@mui/icons-material/Block';
import LockIcon from '@mui/icons-material/Lock';

import { Toggle } from './Toggle';


interface SkillcornerToggleProps {
  isToggled: boolean;
  language: string | undefined;
  setIsToggled?: (isToggled: boolean, callBackProperty?: string) => void;
  toggleStatus: 'blocked' | 'locked' | 'available';
}

export const SkillcornerToggle: React.FC<SkillcornerToggleProps> = ({
  isToggled,
  language,
  setIsToggled,
  toggleStatus,
}) => {

  const title = translate(
    isToggled
      ? 'showEventDataRadar'
      : toggleStatus === 'blocked'
        ? 'physicalDataDoNotExistForSelectedSeason'
        : toggleStatus === 'locked'
          ? 'physicalDataIsNotAvailableForSelectedSeason'
          : 'showPhysicalRadar',
    language
  );

  const toggledColor = '#33ff6a';

  return (
    <div
      className='skillcorner-toggle-container'
      title={title}
      onClick={() => setIsToggled ? setIsToggled(!isToggled) : null}
      style={{
        cursor: setIsToggled ? 'pointer' : 'default',
        gap: 5,
      }}
    >

      <div
        className='skillcorner-toggle-icon'
        style={{ opacity: isToggled ? 1 : 0.5 }}
      >
        <img src={skill_corner_logo} alt='SkillCorner' style={{ width: 10, marginTop: -1 }} />
      </div>

      <div className='skillcorner-toggle-toggle'>
        <Toggle
          isToggled={isToggled}
          setIsToggled={setIsToggled}
          circleColor={isToggled ? toggledColor : undefined}
          toggledBackgroundColor={'default'}
          isSmall={true}
        />
      </div>

      <div
        className='skillcorner-toggle-icon'
        style={{ color: '#ffffff80'}}
      >
        {toggleStatus === 'blocked' && <BlockIcon style={{ fontSize: 14 }} />}
        {toggleStatus === 'locked' && <LockIcon style={{ fontSize: 14 }} />}
      </div>

    </div>
  );
};
